import { call, put, takeLatest } from "redux-saga/effects";
import {
  getClassSectionRequest,
  getClassSectionSuccess,
  getClassSectionFailure,
} from "./classSectionSlice"; 
import classSection from "../../data/classSection.json";
import { GetAllClassSectionMapping } from "../../api/ClassSection/ClassSectionService";

function* fetchClassSectionSaga(action) {
  try {
    const {schoolID} =action.payload;
    const response = yield call(GetAllClassSectionMapping, schoolID);
    yield put(getClassSectionSuccess(response?.data)); 
  } catch (error) {
    yield put(getClassSectionSuccess([])); 
    // yield put(getClassSectionFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassSection() {
  yield takeLatest(getClassSectionRequest.type, fetchClassSectionSaga);
}

